import { ArrayDataSource, SelectionModel } from '@angular/cdk/collections';
import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Scope } from 'src/app/features/assessors/classes/scope';
import { CabsListService } from 'src/app/features/cabs/service/cabs-list.service';
@Component({
  selector: 'app-multi-tree-selection',
  templateUrl: './multi-tree-selection.component.html',
  styles: [
  ]
})
export class MultiTreeSelectionComponent implements OnInit {
  selectedItems: any = [];
  @Input() isView = false;
  @Input() formField = false;
  @Input() classificationCode: any;
  @Input() lazyLoading: boolean = false; //SchemaToken required when lazy loading is enabled.
  @Input() SchemaToken: string; // SchemaToken required when lazy loading is enabled.
  @Output() SelectedItems = new EventEmitter<any>();
  @Input() selectedInput: any;
  /** The selection for checklist */
  @Input() TREE_DATA: Scope[] = [];
  treeSelection = new SelectionModel<Scope>(true /* multiple */);
  treeControl = new NestedTreeControl<Scope>(node => node.child);
  treeDataSource: BehaviorSubject<Scope[]> = new BehaviorSubject<Scope[]>([]);
  hasChild = (_: number, node: Scope) => this.lazyLoading ? (node.has_child) : (!!node.child && node.child.length > 0);
  constructor(private service: CabsListService) {
  }
  ngOnInit(): void {
    this.treeDataSource.next(this.TREE_DATA);
    if (this.selectedInput) {
      this.updateTree();
    }
  }
  // [compareWith]="schemaCompare"
  // schemaCompare(o1, o2): boolean {
  //   return o1 && o2 ? o1 === o2.schema_token : o2.schema_token === o2.schema_token;
  // }
  updateTree() {
    this.treeDataSource.value.forEach(parent => {
      if (this.selectedInput === 'all') {
        this.treeSelection.toggle(parent);
        if (parent.child && parent.child.length) {
          parent.child.forEach(element => {
            this.treeSelection.toggle(element);
          });
        }
      } else {
        if (parent.child && parent.child.length) {
          let childsCount = 0;
          this.selectedInput.forEach(relatedParent => {
            if (typeof relatedParent === 'object' && relatedParent !== null) {
              if (relatedParent.scop_token === parent.scop_token) {
                if (parent.has_child === relatedParent.has_child) {
                  this.treeSelection.toggle(parent);
                }
                relatedParent.child.forEach(child => {
                  const itemFound = parent.child.find(item => child.scop_token === item.scop_token);
                  if (itemFound) {
                    this.treeSelection.toggle(itemFound);
                  }
                });
              }
            } else {
              const itemFound = parent.child.find(item => relatedParent === item.scop_token);
              if (itemFound) {
                this.treeSelection.toggle(itemFound);
                childsCount = childsCount + 1;
              }
              if (childsCount === parent.child.length) {
                this.treeSelection.toggle(parent);
              }
            }
          });
        }
      }
    });
    if (this.formField) {
      setTimeout(() => {
        this.SelectedItems.emit(this.treeSelection.selected);
      }, 10);
    }
  }
  // TREE   configrations //////////////////////////////////////////
  /** Whether all the descendants of the node are selected */
  // descendantsAllSelected(node: Scope): boolean {
  //   const descendants = this.treeControl.getDescendants(node);
  //   return descendants.every(child => this.treeSelection.isSelected(child));
  // }
  descendantsAllSelected(node: Scope): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected =
      descendants.length > 0 &&
      descendants.every((child) => {
        return this.treeSelection.isSelected(child);
      });
    return descAllSelected;
  }
  /** Whether part of the descendants are selected */
  descendantsPartiallySelected(node: Scope): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child => this.treeSelection.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }
  /** Toggle the to-do item selection. Select/deselect all the descendants node */
  todoItemSelectionToggle(node: Scope): void {
    this.treeSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.treeSelection.isSelected(node)
      ? this.treeSelection.select(...descendants)
      : this.treeSelection.deselect(...descendants);
  }
  // END TREE   configrations //////////////////////////////////////////
  isInArray(parentObj, item) {
    return parentObj.some(obj => obj.scop_token === item.scop_token);
  }
  selected(node) {
    this.SelectedItems.emit(this.treeSelection.selected);
  }

  loadSchemaCheldren(scope_token: string, parent: Scope) {
    let model = {
      schema_token: this.SchemaToken,
      scope_token: scope_token,
      level: parent.level
    };
    parent.loading = true;
    this.service.getSchemeSectorPaginated(model).subscribe(
      response => {
        parent.child = response.data.scopes;
        parent.loading = false;
        this.TREE_DATA = this.treeDataSource.value;
        this.treeDataSource.next([]);
        this.treeDataSource.next(this.TREE_DATA);
        if (this.treeSelection.isSelected(parent)) {
          
          response.data.scopes.forEach(scope => {
            this.treeSelection.toggle(scope);
            this.selected(scope)
          });
        }

      },
      error => {
        parent.loading = false;
      }
    )
  }

}
